import { ArrowClockwise } from "@phosphor-icons/react";

export const RefreshButton = () => (
    <button
        type="button"
        data-testid="refresh-btn"
        onClick={() => window.location.reload()}
        className="text-muted-foreground hover:text-primary transition-colors shrink-0"
        title="Muat ulang halaman"
    >
        <ArrowClockwise size={20} weight="light" />
    </button>
);
